module.exports = __webpack_public_path__ + "static/media/101.3afb89be.mp4";